import type {ProjectId} from "../../../metl-models/id/ProjectId.tsx";
import type {ScanContext} from "../scan-model/ScanContext.tsx";
import type {VersionScanPlan} from "./2-ScanVersions.tsx";
import type {EnvironmentScanResult} from "../scan-model/ScanResult.tsx";

async function scanEnvironment(ctx: ScanContext, project: ProjectId): Promise<EnvironmentScanResult[]> {
    const {logError, api} = ctx
    try {
        const envApi = api.groups.get(project.groupName).projects.get(project.projectName).environment
        const environments = await envApi.exportAll()
        ctx.dataWarehouse = environments.environment
        ctx.version = environments.version
        return environments.objects.map(env => ({
            projectId: project,
            environmentName: env.name,
            connectionOptionKeys: Object.keys(env.connectionOptions),
            concurrentConnections: env.concurrentConnections,
            variableCount: Object.keys(env.variables).length
        }))
    } catch(e) {
        logError("An error occurred scanning environments for ${project.groupName}/${project.projectName}", e)
        return []
    }
}

export async function scanEnvironments(ctx: ScanContext, versionScan: VersionScanPlan[]): Promise<EnvironmentScanResult[] | undefined> {
    const {log, logError, startAction} = ctx
    try {
        log("Scanning environments")
        const projects = versionScan.reduce((acc, versionScan) => {
            if(!acc.some(projectId => versionScan.id.groupName === projectId.groupName && versionScan.id.projectName === projectId.projectName)) {
                acc.push({groupName: versionScan.id.groupName, projectName: versionScan.id.projectName})
            }
            return acc
        }, []  as ProjectId[])
        const { reportOne, complete } = startAction(`Scanning environments in ${projects.length} projects`, projects.length)
        const environments = await Promise.all(projects.map(project => {
            const result = scanEnvironment(ctx, project)
            reportOne()
            return result
        }))
        complete()
        return environments.flat()
    } catch (error) {
        logError(`An error occurred scanning environments.`, error)
    }
    return undefined
}